module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/68d9ddbb2aa63310b88c7697e5b0c6c9.svg";